import { FC, SVGProps } from 'react'

export const IconScanner: FC<SVGProps<SVGSVGElement>> = ({ id, ...props }) => {
  const filter0 = `${id}-filter0`
  return (
    <svg
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M25.1516 13.9774V13.0049C25.1516 10.7957 23.3607 9.00488 21.1516 9.00488H20.1791M25.1516 19.3324V20.3049C25.1516 22.514 23.3607 24.3049 21.1516 24.3049H20.1791M14.8241 24.3049H13.8516C11.6424 24.3049 9.85156 22.514 9.85156 20.3049V19.3324M9.85156 13.9774V13.0049C9.85156 10.7957 11.6424 9.00488 13.8516 9.00488H14.8241"
          stroke="#C8F252"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M26 16.6548L9 16.6548"
          stroke="#C8F252"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id={filter0}
          x="0.25"
          y="0.254883"
          width="34.5"
          height="32.7998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6773_115995"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6773_115995"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
